import { Component } from '@verndale/core';
import '../../scss/components/_boat-details-modal.scss';

class BoatDetailsModal extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      close: this.el.querySelector<HTMLElement>('.close'),
      showAllBtn: document.querySelector<HTMLElement>('.show-all-specs-btn'),
      showMoreBtn: document.querySelector<HTMLElement>('.overview-block__show-more-btn'),
    };
  }

  addListeners() {
    (this.dom.close as HTMLElement).addEventListener('click', this.handleClose.bind(this));
    (this.dom.showAllBtn as HTMLElement).addEventListener('click', this.handleShowAll.bind(this));
    (this.dom.showMoreBtn as HTMLElement).addEventListener('click', this.handleShowAll.bind(this));
    document.addEventListener('keydown', this.handleEscClose.bind(this));
    (this.dom.el as HTMLDialogElement).addEventListener('click', this.handleClickOutside.bind(this));
  }

  handleClickOutside(e: MouseEvent) {
    if (e.target === e.currentTarget) {
      (this.el as HTMLDialogElement).close();
      document.body.style.overflow = 'auto';
    }
  }

  handleShowAll() {
    (this.el as HTMLDialogElement).showModal();
    document.body.style.overflow = 'hidden';
  }

  handleClose() {
    (this.el as HTMLDialogElement).close();
    document.body.style.overflow = 'auto';
  }

  handleEscClose(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      (this.el as HTMLDialogElement).close();
      document.body.style.overflow = 'auto';
    }
  }
}

export default BoatDetailsModal;
